import { useParams, useNavigate } from "react-router";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { AdminAllPromosScreenPath } from "./AdminAllPromosScreen.tsx";
import { usePromoById } from "../../ProductService/NormasTeachingPromo/usePromoById.ts";
import { useUpdatePromo } from "../../ProductService/NormasTeachingPromo/useUpdatePromo.ts";
import {
  CreatePromoForm,
  CreatePromoFormValues,
  mapBonusToPayload,
} from "./CreatePromoForm.tsx";
import { mapValidityToPayload } from "../../UI/Utils/validityDays.ts";
import { useAllNormasTeachingProducts } from "../../ProductService/NormasTeachingProduct/useAllNormasTeachingProducts.ts";
import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { AdminMainContainer } from "../../UI/Admin/AdminMainContainer.tsx";

export const EditPromoScreenPath = "/admin/normasteaching/edit-promo/:promoId";

export function EditPromoScreen() {
  const { promoId } = useParams<{ promoId: string }>();
  const { promo, isLoading: loadingPromo } = usePromoById(promoId!);
  const { products, isLoading: loadingProducts } =
    useAllNormasTeachingProducts();
  const { updatePromo, loading: saving } = useUpdatePromo();
  const navigate = useNavigate();

  const onSubmit = async (data: CreatePromoFormValues): Promise<void> => {
    if (!promoId) return;
    await updatePromo(promoId, {
      name: data.name,
      description: data.description,
      bonuses: data.bonuses.map(mapBonusToPayload),
      ...mapValidityToPayload(data),
      applicableProducts: data.applicableProducts,
    });
    navigate(AdminAllPromosScreenPath);
  };

  if (loadingPromo || loadingProducts) return <FullPageLoading />;

  return (
    <Layout>
      <AdminMainContainer>
        <NavBar showAdminSideBarHandle />
        <div className="p-4 flex-1 flex items-center">
          <div className="max-w-[1024px] w-full mx-auto bg-white p-4 rounded-lg flex flex-col gap-4">
            <div>
              <button
                onClick={() => navigate(AdminAllPromosScreenPath)}
                className="text-blue-600 hover:text-blue-800 flex items-center gap-2 mb-4"
              >
                ← Torna alla lista promo
              </button>
              <h1 className="font-bold text-2xl">Modifica Promo</h1>
            </div>
            {promo && (
              <CreatePromoForm
                onSubmit={onSubmit}
                saving={saving}
                initialPromo={promo}
                isEditMode
                products={products}
              />
            )}
          </div>
        </div>
      </AdminMainContainer>
      <Footer />
    </Layout>
  );
}
